/**
 * BookFormatterConfig - Configuration for Book Formatter Application
 */

import { AppConfig, SupportedClass } from '../../../services/baseApplication/types';

export const BOOK_FORMATTER_SUPPORTED_CLASSES: Record<string, SupportedClass> = {
  'paragraph': {
    description: 'Paragraph',
    icon: '¶',
    render: (node) => {
      const el = document.createElement('p');
      el.className = 'book-paragraph';
      el.textContent = node.text || '';
      return el;
    }
  },
  'heading': {
    description: 'Heading',
    icon: 'H',
    render: (node) => {
      const level = node.attrs?.level || 1;
      const el = document.createElement(`h${level}` as any);
      el.className = 'book-heading';
      el.textContent = node.text || '';
      return el;
    }
  },
  'chapter': {
    description: 'Chapter',
    icon: '§',
    render: (node) => {
      const el = document.createElement('div');
      el.className = 'book-chapter';
      const title = document.createElement('h1');
      title.className = 'chapter-title';
      title.textContent = node.attrs?.title || 'Untitled Chapter';
      el.appendChild(title);
      return el;
    }
  },
  'page-break': {
    description: 'Page Break',
    icon: '⤶',
    render: (node) => {
      const el = document.createElement('div');
      el.className = 'page-break';
      el.setAttribute('data-page-break', 'true');
      return el;
    }
  }
};

export const BOOK_FORMATTER_APP_CONFIG: AppConfig = {
  appId: 'book_formatter_v2',
  appName: 'Book',
  containerType: 'page',
  layoutMode: 'flow',
  supportedClasses: BOOK_FORMATTER_SUPPORTED_CLASSES,
  supportedPositionTypes: ['absolute', 'flow'],
  supportsDragDrop: false,
  supportsResize: false,
  supportsRotation: false,
  editorSelector: '.manuscript-editor'
};

// Default format settings (separate from AppConfig)
export const DEFAULT_FORMAT_SETTINGS = {
  pageSize: '6x9',
  orientation: 'portrait' as 'portrait' | 'landscape',
  margins: {
    top: 0.75,
    bottom: 0.75,
    inside: 0.75,
    outside: 0.5
  },
  bodyFont: 'Garamond',
  bodyFontSize: 11,
  lineHeight: 1.5,
  headingFont: 'Garamond',
  headingFontSize: 16,
  chapterPageBreak: true,
  header: {
    enabled: true,
    content: 'Book Title',
    position: 'top' as 'top' | 'bottom'
  },
  footer: {
    enabled: true,
    content: 'pageNumber',
    position: 'bottom' as 'top' | 'bottom'
  },
  tableOfContents: {
    enabled: true,
    style: 'standard' as 'standard' | 'detailed',
    title: 'Table of Contents',
    showPageNumbers: true,
    dotLeader: 'dots' as 'none' | 'dots' | 'dashes'
  }
};
